import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import logo from "../assets/footer_img_2.jpg";
import basuru_img from "../assets/CTA/Basuri2 1.jpg";

const BookPanditForm = () => {
  const [formData, setformData] = useState({
    location_id: "",
    puja_type_id: "",
    puja_id: "",
    pandit_id: "",
    puja_mode: "",
    puja_date: "",
    puja_time: "",
    puja_samagari: "",
    purohit_name: "",
    puhorit_mobile: "",
    puhorit_email: "",
    address: "",
    comment: "",
    pay_mod: "online",
  });

  const [isLoading, setisLoading] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [pujatype, setPujatype] = useState([]);
  const [pujalist, setPujalist] = useState([]);
  const [panditllist, setPanditllist] = useState([]);
  const [categoriesWithPujas, setCategoriesWithPujas] = useState([]);

  // Fetch puja types and categories
  useEffect(() => {
    const selectedCityId = localStorage.getItem("selectedCityId") || "";

    // Fetch all categories
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/category`, {
        params: {
          loc: selectedCityId,
        },
      })
      .then((response) => {
        const categoryList = response.data.data.category_list || [];
        setPujatype(categoryList);

        // Fetch pujas for each category
        const categoriesData = [];

        categoryList.forEach((category) => {
          axios
            .get(
              `${process.env.REACT_APP_API_BASE_URL}/api/v1/puja/category/${category.id}/`
            )
            .then((pujaResponse) => {
              categoriesData.push({
                ...category,
                pujas: pujaResponse.data.data.puja_list || [],
              });

              if (categoriesData.length === categoryList.length) {
                setCategoriesWithPujas(categoriesData);
              }
            })
            .catch((err) => {
              console.error(
                `Error fetching pujas for category ${category.id}:`,
                err.message
              );
            });
        });
      })
      .catch((err) => {
        console.error("Error fetching categories:", err.message);
      });
  }, []);

  // Fetch pandit list
  useEffect(() => {
    const selectedCityId = localStorage.getItem("selectedCityId") || "";

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/pandit/`, {
        params: { loc: selectedCityId },
      })
      .then((response) => {
        const panditList = response.data.data.pandit_list || [];
        setPanditllist(panditList);
      })
      .catch((err) => {
        console.error("Error fetching pandit list:", err.message);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;
    setformData((prev) => ({
      ...prev,
      puja_type_id: selectedId,
    }));

    if (selectedId) {
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/api/v1/puja/category/${selectedId}/`
        )
        .then((response) => {
          setPujalist(response.data.data.puja_list || []);
        })
        .catch((err) => {
          console.error("Error fetching pujas for category:", err.message);
          setPujalist([]);
        });
    }
  };

  // Validate booking before creating
  const validateBooking = async (selectedCityId) => {
    try {
      const validationPayload = {
        location_id: parseInt(selectedCityId),
        puja_type_id: parseInt(formData.puja_type_id),
        puja_id: parseInt(formData.puja_id),
        pandit_id: parseInt(formData.pandit_id),
        puja_samagari: formData.puja_samagari,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking/validate/`,
        validationPayload
      );

      return response.data.data;
    } catch (error) {
      seterrorMessage(
        error.response?.data?.message || "Validation failed. Please try again."
      );
      return null;
    }
  };

  const handleOnlinePayment = async (
    bookingData,
    amount,
    pay_mod
  ) => {
    try {
      const razorpayData = bookingData?.razorpay || {};
      const finalAmount = amount * 100;

      const options = {
        key:
          razorpayData?.api_key || "rzp_live_STkerT80D8w8Lt",
        amount: finalAmount,
        currency: "INR",
        name: formData.purohit_name,
        description: "Puja Booking",
        image: logo,
        handler: async function (response) {
          await confirmPayment(bookingData, response, pay_mod);
        },
        prefill: {
          name: formData.purohit_name,
          email: formData.puhorit_email,
          contact: formData.puhorit_mobile,
        },
        notes: {
          booking_id: bookingData.booking_id,
          puja_mode: formData.puja_mode,
          puja_samagari: formData.puja_samagari,
          frontend_amount: amount,
        },
        theme: {
          color: "#6B2A00",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      seterrorMessage("Failed to open payment gateway.");
      setisLoading(false);
    }
  };

const handleOfflinePayment = async (bookingData) => {
  try {

    console.log("OFFLINE DATA", bookingData);

    const bookingId =
      bookingData?.booking_id ||
      bookingData?.id ||
      bookingData?.order_id ||
      "N/A";

    setformData({
      location_id: "",
      puja_type_id: "",
      puja_id: "",
      pandit_id: "",
      puja_mode: "",
      puja_date: "",
      puja_time: "",
      puja_samagari: "",
      purohit_name: "",
      puhorit_mobile: "",
      puhorit_email: "",
      address: "",
      comment: "",
      pay_mod: "online",
    });

    setisLoading(false);

    toast.success(
      `Booking Successful! Booking ID: ${bookingId}`,
      {
        position: "top-center",
        autoClose: 6000,
      }
    );

  } catch (err) {

    console.error(err);

    setisLoading(false);

    seterrorMessage(
      err?.message || "Offline booking failed"
    );
  }
};

  const confirmPayment = async (bookingData, paymentData, mode) => {
    try {
      const confirmPayload = {
        order_id: bookingData.booking_id,
        payment_id: bookingData.transaction_id,
        razorpay_order_id: paymentData.razorpay_order_id,
        razorpay_payment_id: paymentData.razorpay_payment_id,
        razorpay_signature: paymentData.razorpay_signature,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking/payment-confirm/`,
        confirmPayload
      );

      setformData({
        location_id: "",
        puja_type_id: "",
        puja_id: "",
        pandit_id: "",
        puja_mode: "",
        puja_date: "",
        puja_time: "",
        puja_samagari: "",
        purohit_name: "",
        puhorit_mobile: "",
        puhorit_email: "",
        address: "",
        comment: "",
        pay_mod: "online",
      });

      setisLoading(false);

      const successMsg = `✅ Puja booked successfully! Booking ID: ${bookingData.booking_id}`;
      setsuccessMessage(successMsg);

      const popupMsg = `🎉 Booking Successful!\n\nBooking ID: ${bookingData.booking_id}\n\nThank You! Your Puja Has Been Booked Successfully.`;

      toast.success(popupMsg, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } catch (error) {
      seterrorMessage(
        error.response?.data?.message ||
          "Payment confirmation failed. Please contact support."
      );
      setisLoading(false);
    }
  };

  const handleSubmit = async (e, paymentMode) => {
    e.preventDefault();
    setisLoading(true);
    setsuccessMessage("");
    seterrorMessage("");

    try {
      const selectedCityId = localStorage.getItem("selectedCityId") || "";

      if (!selectedCityId) {
        seterrorMessage("Please select a city first.");
        setisLoading(false);
        return;
      }

      // Validate booking first
      const validationData = await validateBooking(selectedCityId);

      if (!validationData) {
        setisLoading(false);
        return;
      }

      let paymentAmount = 0;

      // PAY OFFLINE BUTTON
      if (paymentMode === "offline") {
        paymentAmount = Number(validationData.offline_dakshina);
      }
      // PAY ONLINE BUTTON
      else {
        switch (formData.puja_samagari) {
          case "self_arrange":
            paymentAmount = Number(validationData.total_self_samagari);
            break;
          case "pandit_arrange":
            paymentAmount = Number(validationData.total_with_samagari);
            break;
          default:
            paymentAmount = Number(validationData.online_total);
        }
      }

      // Create booking
      const bookingPayload = {
        location_id: parseInt(selectedCityId),
        puja_type_id: parseInt(formData.puja_type_id),
        puja_id: parseInt(formData.puja_id),
        pandit_id: parseInt(formData.pandit_id),
        puja_mode: formData.puja_mode,
        puja_date: formData.puja_date,
        puja_time: formData.puja_time,
        puja_samagari: formData.puja_samagari,
        purohit_name: formData.purohit_name,
        puhorit_mobile: formData.puhorit_mobile,
        puhorit_email: formData.puhorit_email,
        address: formData.address,
        comment: formData.comment,
        pay_mod: paymentMode,
        amount: paymentAmount,
      };

      const bookingResponse = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/booking/`,
        bookingPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const bookingData = bookingResponse.data.data;

      console.log(
  "BOOKING RESPONSE",
  bookingResponse.data
);

console.log(
  "BOOKING DATA",
  bookingData
);

      // Handle payment based on mode
      // BOTH BUTTONS USE SAME PAYMENT FLOW
await handleOnlinePayment(
    bookingData,
    paymentAmount,
    paymentMode
);
    
    } catch (error) {
      seterrorMessage(
        error.response?.data?.message ||
          "Failed to process booking. Please try again."
      );
      setisLoading(false);
    }
  };

  return (
    <form onSubmit={(e) => handleSubmit(e, paymentMode)}>
      <div className="container">
        <div className="row justify-content-end">
          <div
            className="col-6 ctapart2 align-items-center pt-4"
            style={{ marginBottom: "20px" }}
          >
            <h1 className="cta_Container_h1 ">Book a Pandit!</h1>
            <p className="cta_Container_p1 mt-2">Puja Details</p>

            <div className="container">
              <div className="row">
                <input
                  type="hidden"
                  name="location_id"
                  value={localStorage.getItem("selectedCityId") || ""}
                />

                <div className="col-6 mt-2">
                  <select
                    className="form-select"
                    name="puja_type_id"
                    value={formData.puja_type_id}
                    onChange={handleCategoryChange}
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select Puja Type
                    </option>
                    {pujatype.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.category_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-6 mt-2">
                  <select
                    className="form-select"
                    name="puja_mode"
                    value={formData.puja_mode}
                    onChange={handleChange}
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                    }}
                    required
                  >
                    <option value="" disabled>
                      Puja Mode
                    </option>
                    <option value="online">Online</option>
                    <option value="offline">Offline</option>
                  </select>
                </div>

                <div className="col-6 mt-2">
                  <input
                    type="date"
                    className="form-control"
                    name="puja_date"
                    value={formData.puja_date}
                    onChange={handleChange}
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                    required
                  />
                </div>

                <div className="col-6 mt-2">
                  <input
                    type="time"
                    className="form-control"
                    name="puja_time"
                    value={formData.puja_time}
                    onChange={handleChange}
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                    required
                  />
                </div>

                <div className="col-6 mt-2">
                  <select
                    name="puja_samagari"
                    value={formData.puja_samagari || ""}
                    onChange={handleChange}
                    className="form-select"
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <option value="">Select Samagari</option>
                    <option value="self_arrange">Self Arrange</option>
                    <option value="pandit_arrange">Purchase by Pandit</option>
                  </select>
                </div>

                <div className="col-6 mt-2">
                  <select
                    className="form-select"
                    name="pandit_id"
                    value={formData.pandit_id}
                    onChange={handleChange}
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select Pandit
                    </option>
                    {Array.isArray(panditllist) && panditllist.length > 0 ? (
                      panditllist.map((pandit) => (
                        <option key={pandit.id} value={pandit.id}>
                          {pandit.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No pandits available for your city</option>
                    )}
                  </select>
                </div>

                <div className="col-6 mt-2">
                  <select
                    className="form-select"
                    name="puja_id"
                    value={formData.puja_id}
                    onChange={handleChange}
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      backgroundColor: "#fff",
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select Puja
                    </option>
                    {pujalist.map((puja) => (
                      <option key={puja.id} value={puja.id}>
                        {puja.puja_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <p className="cta_Container_p2 mt-2">Purohit Details</p>
            <div className="container">
              <div className="row">
                <div className="col-6 mt-2">
                  <input
                    type="text"
                    name="purohit_name"
                    value={formData.purohit_name}
                    onChange={handleChange}
                    placeholder="Full Name"
                    className="w-100"
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                    required
                  />
                </div>
                <div className="col-6 mt-2">
                  <input
                    type="tel"
                    name="puhorit_mobile"
                    value={formData.puhorit_mobile}
                    onChange={handleChange}
                    placeholder="Mobile Number"
                    className="w-100"
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                    required
                  />
                </div>
                <div className="col-12 mt-2">
                  <input
                    type="email"
                    name="puhorit_email"
                    value={formData.puhorit_email}
                    onChange={handleChange}
                    placeholder="Email"
                    className="w-100"
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                    required
                  />
                </div>
                <div className="col-6 mt-2">
                  <input
                    type="text"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Address"
                    className="w-100"
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                    required
                  />
                </div>
                <div className="col-6 mt-2">
                  <textarea
                    className="form-control"
                    name="comment"
                    value={formData.comment}
                    onChange={handleChange}
                    placeholder="Additional Comment"
                    rows="2"
                    style={{
                      padding: "8px",
                      fontSize: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                    }}
                  ></textarea>
                </div>
              </div>
            </div>

            <p className="cta_Container_p2 mt-2">Choose Payment Method & Pay</p>
            <div className="container">
              <div className="row">
                <div className="col-6 mt-2">
                  <button
                    type="button"
                    className="btn w-100"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit(e, "online");
                    }}
                    disabled={isLoading}
                    style={{
                      backgroundColor: "#6B2A00",
                      color: "white",
                      padding: "10px 12px",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                      cursor: isLoading ? "not-allowed" : "pointer",
                      fontSize: "14px",
                      opacity: isLoading ? 0.6 : 1,
                    }}
                  >
                    {isLoading ? "⏳ Processing..." : "💳 Online Payment"}
                  </button>
                </div>
                <div className="col-6 mt-2">
                  <button
                    type="button"
                    className="btn w-100"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit(e, "offline");
                    }}
                    disabled={isLoading}
                    style={{
                      backgroundColor: "#E3952A",
                      color: "white",
                      padding: "10px 12px",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                      cursor: isLoading ? "not-allowed" : "pointer",
                      fontSize: "14px",
                      opacity: isLoading ? 0.6 : 1,
                    }}
                  >
                    {isLoading ? "⏳ Processing..." : "💰 Offline Payment"}
                  </button>
                </div>
              </div>
            </div>

            {/* <div className="mt-2">
              <img
                src={basuru_img}
                alt="Basuru"
                className="img-fluid w-100"
                style={{
                  borderRadius: "6px",
                }}
              />
            </div> */}
          </div>
        </div>
      </div>
    </form>
  );
};

export default BookPanditForm;
